import { render, staticRenderFns } from "./CenterLogo.vue?vue&type=template&id=3ff5e1d6&scoped=true&"
import script from "./CenterLogo.vue?vue&type=script&lang=js&"
export * from "./CenterLogo.vue?vue&type=script&lang=js&"
import style0 from "./CenterLogo.vue?vue&type=style&index=0&id=3ff5e1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5e1d6",
  null
  
)

export default component.exports